/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { reduce } from 'lodash'
import Select from 'react-select'
import { Form } from 'semantic-ui-react'

export default class DistrictField extends React.PureComponent {
  render() {
    const { onChange, districts, selectedDistrict, selectedDistricts, disabled } = this.props

    const data = reduce(
      districts,
      (result, district) => {
        const option = {
          label: district.name,
          value: district.id,
          isDisabled: selectedDistricts.includes(district.id)
        }

        if (selectedDistrict.includes(district.id)) {
          result.existedValue.push(option)
        }

        result.options.push(option)

        return result
      },
      { existedValue: [], options: [] }
    )

    return (
      <Form.Field>
        <label>District</label>
        <Select
          menuPlacement="top"
          isSearchable
          isRtl={false}
          isDisabled={disabled}
          value={data.existedValue}
          className="basic-single"
          onChange={onChange}
          options={data.options}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/serviceAvailability/components/DistrictField.js